<template>
  <a-form-item v-if="!item.isshow">
    <a-checkbox
      @change="onChange"
    >
      {{ item.showname || item.name }}
    </a-checkbox>
  </a-form-item>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    onChange (e) {
      this.item.isTemp = e.target.checked
      // this.$set(this.item, 'isTemp', e.target.checked)
    }
  }
}
</script>
